import { useTranslate } from "@tolgee/react";
import React from "react";
import { QuantityUnit } from "../../../clients/graphqlTypes.js";

const units = new Set<QuantityUnit>([
  "mm",
  "cm",
  "m",
  "m2",
  "m3",
  "l",
  "gr",
  "kg",
  "t",
  "piece",
  "lump_sum",
  "hr",
  "day",
  "month",
  "pair",
  "cm3",
  "cm2",
  "doz",
  "hl",
  "km",
  "set",
]);

export function useQuantityUnits() {
  const { t } = useTranslate("Units");

  const quantityUnitLabels: Record<QuantityUnit, string> = React.useMemo(
    () => ({
      cm: t("cm"),
      mm: t("mm"),
      m: t("m"),
      m2: t("m2"),
      m3: t("m3"),
      gr: t("gr"),
      kg: t("kg"),
      l: t("l"),
      lump_sum: t("lumpsum"),
      piece: t("piece"),
      t: t("t"),
      hr: t("hr"),
      day: t("day"),
      month: t("month"),
      pair: t("pair"),
      cm3: t("cm3"),
      cm2: t("cm2"),
      doz: t("doz"),
      hl: t("hl"),
      km: t("km"),
      set: t("set"),
    }),
    [t]
  );

  const quantityUnitOptions = React.useMemo(
    () =>
      [...units].map(unit => ({
        label: quantityUnitLabels[unit],
        value: unit,
      })),
    [quantityUnitLabels]
  );

  return { quantityUnitLabels, quantityUnitOptions };
}
